import {
  LayoutDashboard,
  ShoppingCart,
  TrendingUp,
  BarChart3,
  CreditCard,
  Shield,
} from "lucide-react";
export const getAbbreviation = (name: string) => {
  if (!name) return "?";
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  } else {
    return name.substring(0, 2).toUpperCase();
  }
};

export const navigation = [
  { name: "Dashboard", href: "/platform", icon: LayoutDashboard },
  { name: "MoMT", href: "/momt", icon: TrendingUp },
  { name: "Purchases", href: "/purchases", icon: ShoppingCart },
];

export const newAdminNavigation = [
  { name: "Dashboard", href: "/admin/dashboard", icon: Shield },
  { name: "Purchases", href: "/admin/purchases", icon: CreditCard },
];

export const nigerianNetworks = [
  { value: "MTN", label: "MTN" },
  { value: "GLO", label: "Glo" },
  { value: "AIRTEL", label: "AIRTEL" },
  { value: "9MOBILE", label: "9mobile" },
];
